import type { PhotoWithUrl } from "./types";

export function getPhotoTag(photo: PhotoWithUrl): string | null {
  const name = photo.document_name.toLowerCase();
  if (name.includes('main') || name.includes('primary')) return 'Main Photo';
  if (name.includes('nameplate') || name.includes('name plate')) return 'Nameplate Photo';
  if (name.includes('qr') || name.includes('qr code')) return 'QR Photo';
  return null;
}
